import { makeStyles } from 'vendor/material';
import { Box, Tooltip } from 'vendor/material';
import { InformationOutline } from 'mdi-material-ui';
import { fontWeightMediumLarge } from 'utils/fontWeightConstants';
import cn from 'classnames';

const useStyles = makeStyles((theme) => ({
  label: {
    fontSize: theme.typography.pxToRem(12),
    fontWeight: fontWeightMediumLarge,
    color: theme.palette.NEUTRAL300,
  },
  formLabel: {
    display: 'flex',
    alignItems: 'center',
  },
  tooltip: {
    marginLeft: theme.spacing(0.5),
  },
}));

export const InputLabel = ({
  className,
  disabled,
  dataId,
  tooltipText,
  label,
  name,
  required,
}: {
  className?: string;
  dataId?: string;
  disabled?: boolean;
  label: string;
  name?: string;
  required?: boolean;
  tooltipText?: string;
}) => {
  const classes = useStyles();

  return (
    <Box className={cn(classes.formLabel, className)}>
      <label
        aria-disabled={disabled}
        className={classes.label}
        data-id={dataId}
        htmlFor={name}
      >
        {label}
        {required ? <span style={{ color: 'red' }}>&nbsp;*</span> : ''}
      </label>

      {tooltipText && (
        <Tooltip
          id={dataId}
          className={classes.tooltip}
          title={tooltipText}
          placement="top-start"
        >
          <InformationOutline fontSize="small" />
        </Tooltip>
      )}
    </Box>
  );
};
